export default __webpack_public_path__ + "static/media/job_offer17_xl.4083fbe9.jpg";